/** True when the logged-in user has the admin role. */
export const isAdminUser = (user) => String(user?.role || '').toLowerCase() === 'admin';
